module.exports = __webpack_public_path__ + "images/emails/logo-b0fd9dc6.gif";